import React, { FunctionComponent } from 'react';

import BaseFooter from '@gojob/ui-bits/Footer';

import { FooterFragmentResponse } from '../../fragments/footer';
import BCorpLogo from './BCorpLogo';
import CookieLink from './CookieLink';
import Section from './Section';
import Social from './Social';

interface FooterProps extends FooterFragmentResponse {}

const Footer: FunctionComponent<FooterProps> = (props) => {
  const { sections, socialLinks } = props;

  return (
    <BaseFooter>
      {sections.map((section, index) => {
        if (index === 0) {
          return (
            <Section key={index} {...section}>
              <CookieLink />
            </Section>
          );
        }
        return <Section key={index} {...section} />;
      })}

      {socialLinks ? <Social socialLinks={socialLinks} /> : null}
    </BaseFooter>
  );
};

export default Footer;
